import React from 'react';
import PageDescription from '../components/baseComponents/head/pageDescription/PageDescription';
import defaultPage from '../constants/page-description';
import PageComponent from '../components/features/pageComponent/PageComponent';

export default function Home({ callbacks }) {
  return (
    <div className='container'>
      <PageDescription {...defaultPage} />
      <PageComponent callbacks={callbacks} />
    </div>
  );
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
